import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useEffect } from "react";

type Role = "colaborador" | "rh" | "financeiro";

export const RoleGuard = ({
  role,
  children,
}: {
  role: Role | Role[];
  children: React.ReactNode;
}) => {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const allowed = Array.isArray(role) ? role : [role];

  useEffect(() => {
    if (loading) return;
    if (!user) {
      nav("/login", { replace: true });
    } else if (!allowed.includes(user.role as Role)) {
      nav(user.role === "rh" ? "/rh" : "/colaborador", { replace: true });
    }
  }, [user, loading, nav]);

  if (loading) return null;
  if (!user || !allowed.includes(user.role as Role)) return null;
  return <>{children}</>;
};
